var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 80,
    viewBox: "0 0 299 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "PDF",
    x: 0,
    y: 0,
    width: 299,
    height: 80,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOUTON",
    transform: "translate(243.936 17.713)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -243.94, -17.71)",
    filter: "url(#PDF)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "PDF-2",
    "data-name": "PDF",
    width: 281,
    height: 62,
    rx: 31,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14829",
    "data-name": "Path 14829",
    d: "M-9.732-14.04a6.343,6.343,0,0,1,.624,2.832,6.267,6.267,0,0,1-.624,2.82,5.537,5.537,0,0,1-1.608,2,6.684,6.684,0,0,1-4.128,1.536h-3v2.712a6.972,6.972,0,0,1-.036.828,1.923,1.923,0,0,1-.228.636q-.336.648-1.872.648-1.68,0-1.968-.888a4.013,4.013,0,0,1-.144-1.248V-15.48a6.972,6.972,0,0,1,.036-.828,1.923,1.923,0,0,1,.228-.636q.336-.648,1.872-.648h5.136a6.655,6.655,0,0,1,4.1,1.536A5.514,5.514,0,0,1-9.732-14.04ZM-15.444-9.1a2.326,2.326,0,0,0,1.416-.528,1.862,1.862,0,0,0,.7-1.584,1.9,1.9,0,0,0-.7-1.6,2.324,2.324,0,0,0-1.44-.54h-3V-9.1Zm10.032-8.52,4.44.024a8.616,8.616,0,0,1,6.12,2.508,8.174,8.174,0,0,1,2.64,6.168A8.62,8.62,0,0,1,5.208-2.64,8.456,8.456,0,0,1-1.044-.024H-5.436q-1.464,0-1.824-.6A3.189,3.189,0,0,1-7.548-2.16V-15.5a6.928,6.928,0,0,1,.036-.84,1.935,1.935,0,0,1,.228-.624Q-6.948-17.616-5.412-17.616ZM-.972-4.272a4.489,4.489,0,0,0,3.12-1.284A4.206,4.206,0,0,0,3.54-8.784a4.335,4.335,0,0,0-1.356-3.252A4.433,4.433,0,0,0-1-13.344H-3.3v9.072Zm21.96-13.32a6.972,6.972,0,0,1,.828.036,1.812,1.812,0,0,1,.624.228,1.065,1.065,0,0,1,.492.648,4.2,4.2,0,0,1,.144,1.224,4.2,4.2,0,0,1-.144,1.224,1.007,1.007,0,0,1-.5.636,2.059,2.059,0,0,1-.636.216,7.254,7.254,0,0,1-.852.036H13.6v2.424h4.728a7.254,7.254,0,0,1,.852.036,1.923,1.923,0,0,1,.636.228q.624.36.624,1.9,0,1.68-.912,1.992a4.487,4.487,0,0,1-1.224.12H13.6v4.536a6.928,6.928,0,0,1-.036.84,1.935,1.935,0,0,1-.228.624Q13,0,11.46,0,9.78,0,9.492-.912a3.774,3.774,0,0,1-.144-1.224V-15.48A2.325,2.325,0,0,1,9.8-17.148a2.508,2.508,0,0,1,1.728-.444Z",
    transform: "translate(-87.936 28.287)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_2_",
    "data-name": "download (2)",
    transform: "translate(-203.832 2.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10484",
    "data-name": "Path 10484",
    d: "M22.143,31.948a1.247,1.247,0,0,1-.9-.387l-7.9-8.312a1.248,1.248,0,0,1,.9-2.106h3.74V14.078A2.081,2.081,0,0,1,20.065,12h4.156A2.081,2.081,0,0,1,26.3,14.078v7.065h3.74a1.248,1.248,0,0,1,.9,2.106l-7.9,8.312A1.25,1.25,0,0,1,22.143,31.948Z",
    transform: "translate(8.609 7.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10485",
    "data-name": "Path 10485",
    d: "M12.827,15.84c-.349.233-.665.482-1,.748A4.02,4.02,0,0,1,12.827,15.84Z",
    transform: "translate(7.836 10.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10486",
    "data-name": "Path 10486",
    d: "M28.233.182a14.531,14.531,0,0,0-11.6,3.142A14.531,14.531,0,0,0,5.027.182,2.929,2.929,0,0,0,2.5,3.057V21.293a2.919,2.919,0,0,0,3.258,2.876,12.25,12.25,0,0,1,7.564,1.6,13.641,13.641,0,0,1,2.494,1.762,1.208,1.208,0,0,0,1.629,0,6.7,6.7,0,0,1,.532-.432c.017-.017.017-.017.033-.017.332-.266.648-.515,1-.748.017,0,.017-.017.033-.017q.449-.3.9-.549a11.865,11.865,0,0,1,1.679-.8v-2.66a15.664,15.664,0,0,0-4.987,2.676,15.242,15.242,0,0,0-9.459-3.391,14.715,14.715,0,0,0-1.7.1.431.431,0,0,1-.349-.116.355.355,0,0,1-.133-.283V3.057a.442.442,0,0,1,.382-.416,12.256,12.256,0,0,1,10.44,3.242,1.22,1.22,0,0,0,1.629,0,12.307,12.307,0,0,1,10.44-3.242.442.442,0,0,1,.382.416V16.622H30.76V3.057A2.929,2.929,0,0,0,28.233.182Z",
    transform: "translate(1.656 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10487",
    "data-name": "Path 10487",
    d: "M21.594,24.442q-.449.249-.9.549c-.017,0-.017.017-.033.017-.349.233-.665.482-1,.748-.017,0-.017,0-.033.017a4.28,4.28,0,0,0-.848,1.164H2.909A2.923,2.923,0,0,1,0,24.026V4.909A2.92,2.92,0,0,1,2.892,2H4.987a1.247,1.247,0,1,1,0,2.494H2.909a.422.422,0,0,0-.416.416V24.026a.412.412,0,0,0,.416.416Z",
    transform: "translate(0 1.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10488",
    "data-name": "Path 10488",
    d: "M24.484,4.909V16.795a5.205,5.205,0,0,0-2.494-1.33V4.909a.412.412,0,0,0-.416-.416H19.5A1.247,1.247,0,0,1,19.5,2h2.078a2.923,2.923,0,0,1,2.909,2.909Z",
    transform: "translate(12.088 1.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10489",
    "data-name": "Path 10489",
    d: "M11.5,26.354a1.247,1.247,0,0,1-1.247-1.247V3.5a1.247,1.247,0,0,1,2.494,0V25.107A1.247,1.247,0,0,1,11.5,26.354Z",
    transform: "translate(6.789 1.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "download_2_2",
    "data-name": "download (2)",
    transform: "translate(-203.832 2.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10484-2",
    "data-name": "Path 10484",
    d: "M22.143,31.948a1.247,1.247,0,0,1-.9-.387l-7.9-8.312a1.248,1.248,0,0,1,.9-2.106h3.74V14.078A2.081,2.081,0,0,1,20.065,12h4.156A2.081,2.081,0,0,1,26.3,14.078v7.065h3.74a1.248,1.248,0,0,1,.9,2.106l-7.9,8.312A1.25,1.25,0,0,1,22.143,31.948Z",
    transform: "translate(8.609 7.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10485-2",
    "data-name": "Path 10485",
    d: "M12.827,15.84c-.349.233-.665.482-1,.748A4.02,4.02,0,0,1,12.827,15.84Z",
    transform: "translate(7.836 10.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10486-2",
    "data-name": "Path 10486",
    d: "M28.233.182a14.531,14.531,0,0,0-11.6,3.142A14.531,14.531,0,0,0,5.027.182,2.929,2.929,0,0,0,2.5,3.057V21.293a2.919,2.919,0,0,0,3.258,2.876,12.25,12.25,0,0,1,7.564,1.6,13.641,13.641,0,0,1,2.494,1.762,1.208,1.208,0,0,0,1.629,0,6.7,6.7,0,0,1,.532-.432c.017-.017.017-.017.033-.017.332-.266.648-.515,1-.748.017,0,.017-.017.033-.017q.449-.3.9-.549a11.865,11.865,0,0,1,1.679-.8v-2.66a15.664,15.664,0,0,0-4.987,2.676,15.242,15.242,0,0,0-9.459-3.391,14.715,14.715,0,0,0-1.7.1.431.431,0,0,1-.349-.116.355.355,0,0,1-.133-.283V3.057a.442.442,0,0,1,.382-.416,12.256,12.256,0,0,1,10.44,3.242,1.22,1.22,0,0,0,1.629,0,12.307,12.307,0,0,1,10.44-3.242.442.442,0,0,1,.382.416V16.622H30.76V3.057A2.929,2.929,0,0,0,28.233.182Z",
    transform: "translate(1.656 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10487-2",
    "data-name": "Path 10487",
    d: "M21.594,24.442q-.449.249-.9.549c-.017,0-.017.017-.033.017-.349.233-.665.482-1,.748-.017,0-.017,0-.033.017a4.28,4.28,0,0,0-.848,1.164H2.909A2.923,2.923,0,0,1,0,24.026V4.909A2.92,2.92,0,0,1,2.892,2H4.987a1.247,1.247,0,1,1,0,2.494H2.909a.422.422,0,0,0-.416.416V24.026a.412.412,0,0,0,.416.416Z",
    transform: "translate(0 1.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10488-2",
    "data-name": "Path 10488",
    d: "M24.484,4.909V16.795a5.205,5.205,0,0,0-2.494-1.33V4.909a.412.412,0,0,0-.416-.416H19.5A1.247,1.247,0,0,1,19.5,2h2.078a2.923,2.923,0,0,1,2.909,2.909Z",
    transform: "translate(12.088 1.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10489-2",
    "data-name": "Path 10489",
    d: "M11.5,26.354a1.247,1.247,0,0,1-1.247-1.247V3.5a1.247,1.247,0,0,1,2.494,0V25.107A1.247,1.247,0,0,1,11.5,26.354Z",
    transform: "translate(6.789 1.489)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBtn);
export default __webpack_public_path__ + "static/media/download-btn.af73fbc3.svg";
export { ForwardRef as ReactComponent };